import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FooterComponent} from './components/footer/footer.component';
import { UserMenuComponent } from './components/user-menu/user-menu.component';
import { NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {RouterModule} from '@angular/router';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { LoadingDirective } from './directives/loading.directive';
import { DotnavComponent } from './components/dotnav/dotnav.component';
import { DotComponent } from './components/dot/dot.component';


@NgModule({
  declarations: [FooterComponent, UserMenuComponent, SpinnerComponent, LoadingDirective, DotnavComponent, DotComponent],
  imports: [
    CommonModule,
    NgbDropdownModule,
    RouterModule
  ],
  exports: [FooterComponent, UserMenuComponent, SpinnerComponent, LoadingDirective, DotnavComponent, DotComponent]
})
export class SharedModule { }
